import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-auto-ria',
  templateUrl: './auto-ria.component.html',
  styleUrls: ['./auto-ria.component.scss', '../olx/olx.component.scss']
})
export class AutoRiaComponent {
  menuOpen = false;
  reviews = [
    { text: 'auto_page.testimonials_1_text', author: 'auto_page.testimonials_1_author' }
  ];
  toggleMenu(): void { this.menuOpen = !this.menuOpen; }
  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) { el.scrollIntoView({ behavior: 'smooth' }); }
    if (this.menuOpen) { this.toggleMenu(); }
  }

  protected readonly environment = environment;
}
